
define('template!adminWebhookHistoryEditPopupView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="popup-header">\n  <div class="meta">\n    <span class="type">' +
((__t = ( _.escape(type) )) == null ? '' : __t) +
'</span>\n    <span class="status status-' +
((__t = ( _.escape(status.toLowerCase()) )) == null ? '' : __t) +
'">' +
((__t = ( _.escape(status) )) == null ? '' : __t) +
'</span>\n  </div>\n</div>\n\n<div class="popup-body">\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(urlLabel) )) == null ? '' : __t) +
'</label>\n    <div class="url-value">' +
((__t = ( _.escape(url) )) == null ? '' : __t) +
'</div>\n  </div>\n\n  <div class="form-row json-row">\n    <label>' +
((__t = ( _.escape(afterLabel) )) == null ? '' : __t) +
'</label>\n    <textarea class="after-input" spellcheck="false">' +
((__t = ( _.escape(afterObject) )) == null ? '' : __t) +
'</textarea>\n  </div>\n</div>\n\n<div class="popup-footer">\n  <button class="btn btn-cancel">' +
((__t = ( _.escape(cancelLabel) )) == null ? '' : __t) +
'</button>\n  <button class="btn btn-save">' +
((__t = ( _.escape(saveLabel) )) == null ? '' : __t) +
'</button>\n  <button class="btn btn-save-retry">' +
((__t = ( _.escape(saveRetryLabel) )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};});

